import axios from 'axios';
import { useCombobox } from 'downshift';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ADDRESS_AUTOCOMPLETE_URL, ADDRESS_GET } from '../../../constants/paths/api';
import theme from '../../../constants/theme';
import Button from '../../base/button';
import { Input } from '../../base/forms/input';
import { RawLoader } from '../../loading/loading';
import * as StyledAddressSearch from './addressSearch.styles';
import AddressSearchResults from './addressSearchResults';

interface Props {}

const AddressSearch: FC<Props> = () => {
	const [value, setValue] = useState('');
	const [data, setData] = useState(null);
	const [fetchingData, setFetchingData] = useState(false);
	const { t } = useTranslation('generalPostInfo');
	const [autocompleteList, setAutocompleteList] = useState([]);

	const onButtonClick = async ({ selectedItem, keyCode }) => {
		let address = value;
		if (selectedItem) {
			setValue(selectedItem);
			address = selectedItem;
		}
		if (keyCode) {
			if (keyCode !== 13) {
				return;
			}
		}
		// setStopAutocomplete(true);
		try {
			const response = await axios(`${ADDRESS_GET}?address=${address}`);
			setData(response.data);
		} catch (err) {
			console.log(err);
		}
	};

	const onChange = async e => {
		setValue(e.target.value);
		// if (stopAutocomplete) setStopAutocomplete(false);
		setFetchingData(true);
		try {
			const response = await axios(`${ADDRESS_AUTOCOMPLETE_URL}?address=${e.target.value.toLowerCase()}`);
			setAutocompleteList(response.data.slice(0, 7));
			setFetchingData(false);
		} catch (err) {
			console.log(err);
		}
	};

	const { isOpen, getInputProps, getMenuProps, highlightedIndex, getItemProps } = useCombobox({
		items: autocompleteList,
		onSelectedItemChange: onButtonClick,
		circularNavigation: true,
	});

	return (
		<StyledAddressSearch.Wrapper>
			<StyledAddressSearch.InputWrapper>
				<StyledAddressSearch.InputAndDropdownWrapper>
					<Input
						placeholder={`${t('address-search.search')}...`}
						{...getInputProps({
							onChange: onChange,
						})}
					/>
					<StyledAddressSearch.DropdownWrapper>
						<StyledAddressSearch.List {...getMenuProps()}>
							{isOpen &&
								!fetchingData &&
								autocompleteList.map((option, index) => (
									<StyledAddressSearch.Item
										highlighted={highlightedIndex === index}
										key={`${option}${index}`}
										{...getItemProps({
											item: option,
											index,
											style: {
												backgroundColor:
													index === highlightedIndex ? theme.colors.grayLighter : null,
											},
										})}>
										{option}
									</StyledAddressSearch.Item>
								))}
							{isOpen && fetchingData && (
								<StyledAddressSearch.LoaderContainer>
									<RawLoader />
								</StyledAddressSearch.LoaderContainer>
							)}
						</StyledAddressSearch.List>
					</StyledAddressSearch.DropdownWrapper>
				</StyledAddressSearch.InputAndDropdownWrapper>
				<StyledAddressSearch.ButtonWrapper>
					<Button primary mobileBlock onClick={onButtonClick}>
						{t('address-search.search')}
					</Button>
				</StyledAddressSearch.ButtonWrapper>
			</StyledAddressSearch.InputWrapper>
			<StyledAddressSearch.TableWrapper>
				<AddressSearchResults data={data} />
			</StyledAddressSearch.TableWrapper>
		</StyledAddressSearch.Wrapper>
	);
};

export default AddressSearch;
